  <template>
    <div>
      <!-- 统一弹窗 -->
      <base-modal
        class="create-user-modal"
        v-if="visible || successVisible"
        head-img-url=""
        :show-close="true"
        :hide-footer="true"
        @close="handleModalClose">
        <template #title>
         {{ successVisible ? (isEdit ? '账号编辑成功~' : '账号创建成功~') : (isEdit ? '编辑账号' : '创建账号') }}
        </template>
        <div slot="content" class="modal-content">
          <!-- 创建表单内容 -->
          <div v-if="!successVisible" class="create-form-content">
            <el-form
              :model="formData"
              :rules="rules"
              ref="createForm"
              label-width="120px">
              <el-form-item label="业务类型:" prop="level">
                <el-radio-group v-model="formData.level" >
                  <!-- <el-radio label="MATHS_TALENTS_1" value="MATHS_TALENTS_1">丘成桐少年班</el-radio> -->
                  <el-radio :label="item.id" v-for="(item,index) in EXAM_LEVEL_TYPE" :key="index" >{{ item.label }}</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="用户手机号:" prop="mobile">
                <el-input
                  v-model="formData.mobile"
                  :disabled="isEdit"
                  placeholder="请输入"
                  maxlength="11">
                </el-input>
              </el-form-item>

              <el-form-item label="角色:" prop="roles">
                <el-checkbox-group v-model="formData.roles" @change="handleRoleChange">
                  <el-checkbox label="ADMIN">管理员</el-checkbox>
                  <el-checkbox label="TEACHER">老师</el-checkbox>
                  <el-checkbox label="STUDENT">学生</el-checkbox>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item label="用户名称:" prop="username">
                <el-input
                  v-model="formData.username"
                  placeholder="请选择"
                  show-word-limit>
                </el-input>
              </el-form-item>

              <!-- 管理员关联学校 -->
              <el-form-item
                v-if="formData.roles.includes('ADMIN')"
                label="管理员关联学校:"
                prop="adminSchools"
                >
                <el-select
                  v-model="formData.adminSchools"
                  multiple
                  filterable
                  placeholder="请选择"
                  @change="handleAdminSchoolChange">
<!--                  <el-option label="全部" :value="0" :disabled="!formData.adminSchools.includes(0) && formData.adminSchools.length > 0"></el-option>-->
                  <el-option
                    v-for="school in schoolList"
                    :key="school.id"
                    :label="school.schoolName"
                    :value="school.id"
                    :disabled="(formData.adminSchools.includes(0) && school.id !== 0) || (school.id === 0 && !formData.adminSchools.includes(0) && formData.adminSchools.length > 0)">
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- 老师关联学校 -->
              <el-form-item
                v-if="formData.roles.includes('TEACHER')"
                label="老师关联学校:"
                prop="teacherSchools"
              >
                <el-select
                  v-model="formData.teacherSchools"
                  multiple
                  filterable
                  placeholder="请选择"
                  @change="handleTeacherSchoolChange">
<!--                  <el-option label="全部" :value='0'></el-option>-->
                  <el-option
                    v-for="school in schoolList"
                    :key="school.id"
                    :label="school.schoolName"
                    :value="school.id"
                    :disabled="(formData.teacherSchools.includes(0) && school.id !==0) || (school.id === 0 && !formData.teacherSchools.includes(0) && formData.teacherSchools.length > 0)">
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- 学生关联学校 -->
              <el-form-item
                v-if="formData.roles.includes('STUDENT')"
                label="学生关联学校:"
                prop="studentSchool"
                >
                <el-select
                  filterable
                  v-model="formData.studentSchool"
                  placeholder="请选择">
<!--                  <el-option label="全部" :value=0></el-option>-->
                  <el-option
                    v-for="school in schoolList.filter(school => school.id !== 0)"
                    :key="school.id"
                    :label="school.schoolName"
                    :value="school.id">
                  </el-option>
                </el-select>
              </el-form-item>

              <!-- 学生年级 -->
              <el-form-item
                v-if="formData.roles.includes('STUDENT')"
                label="学生年级:"
                prop="grade">
                <el-select
                  v-model="formData.grade"
                  placeholder="请选择">
                  <el-option
                    v-for="grade in gradeList"
                    :key="grade.value"
                    :label="grade.label"
                    :value="grade.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>

            <div class="form-footer">
              <el-button @click="handleCancel">取消</el-button>
              <el-button type="primary" @click="handleSubmit" :loading="submitting">{{ isEdit ? '保存' : '提交' }}</el-button>
            </div>
          </div>

          <!-- 成功内容 -->
          <div v-if="successVisible" class="success-content">
            <div class="info-item">
              <span class="label">业务类型:</span>
              <span class="value">{{ EXAM_LEVEL_TYPE_ENUM[successData.level] }}</span>
            </div>

            <div class="info-item">
              <span class="label">用户手机号:</span>
              <span class="value">{{ successData.mobile }}</span>
            </div>

            <div class="info-item">
              <span class="label">角色:</span>
              <div class="role-tags">
                <roles-tag
                    v-for="(role, index) in  successData.roles"
                    :key="index"
                    :role="role"
                />
              </div>
            </div>

            <div class="info-item">
              <span class="label">用户名称:</span>
              <span class="value">{{ successData.username }}</span>
            </div>

            <div class="info-item" v-if="successData.adminSchools">
              <span class="label">管理员学校:</span>
              <span class="value">{{ successData.adminSchools }}</span>
            </div>

            <div class="info-item" v-if="successData.teacherSchools">
              <span class="label">老师学校:</span>
              <span class="value">{{ successData.teacherSchools }}</span>
            </div>

            <div class="info-item" v-if="successData.studentSchool">
              <span class="label">学生学校:</span>
              <span class="value">{{ successData.studentSchool }}</span>
            </div>

            <div class="info-item" v-if="successData.grade">
              <span class="label">学生年级:</span>
              <span class="value">{{ successData.grade }}</span>
            </div>

            <div class="account-info"  v-if="successData.userPass">
              <div class="account-item">
                <span class="label">账号:</span>
                <span class="value">{{ successData.userPass.username }}</span>
                <el-button type="text" @click="copyToClipboard(`账号: ${successData.userPass.username}  密码: ${successData.userPass.password}`)">复制</el-button>
              </div>

              <div class="account-item">
                <span class="label">密码:</span>
                <span class="value">{{ successData.userPass.password }}</span>
              </div>
            </div>
          </div>
        </div>
      </base-modal>
    </div>
  </template>

<script>
import { Form, FormItem, Input, Select, Option, Checkbox, CheckboxGroup, Radio, RadioGroup, Button, Tag, Message } from "element-ui";
import BaseModal from '@/components/baseModal.vue';
import {createUser, getUserSchools} from '@/api/qzTeacher';
import {EXAM_LEVEL_TYPE_ENUM,USER_GRADE_MAP, EXAM_LEVEL_TYPE} from '@/common/constant/qz';
import RolesTag from "@/pages/teacher/components/rolesTag.vue";

export default {
  name: 'CreateUserModal',
  components: {
    'base-modal': BaseModal,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-select': Select,
    'el-option': Option,
    'el-checkbox': Checkbox,
    'el-checkbox-group': CheckboxGroup,
    'el-radio': Radio,
    'el-radio-group': RadioGroup,
    'el-button': Button,
    'roles-tag': RolesTag,
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 手机号验证
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入用户手机号'));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号格式'));
      } else {
        callback();
      }
    };

    // 用户名验证
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入用户名称'));
      } else {
        callback();
      }
    };


    // 角色验证
    const validateRoles = (rule, value, callback) => {
      if (!value || value.length === 0) {
        callback(new Error('请至少选择一个角色'));
      } else {
        callback();
      }
    };

    // 业务类型验证（已移除，因为有默认值）

    return {
      visible: false,
      successVisible: false,
      submitting: false,
      EXAM_LEVEL_TYPE,
      EXAM_LEVEL_TYPE_ENUM,
      schoolList:[],
      formData: {
        level: 'MATHS_TALENTS_1',
        mobile: '',
        roles: [],
        username: '',
        adminSchools: [],
        teacherSchools: [],
        studentSchool: '',
        grade: ''
      },
      successData: {},
      rules: {
        level: [
          { required: true, message: '请选择业务类型', trigger: 'change' }
        ],
        mobile: [
          { required: true,validator: validateMobile, trigger: 'blur' }
        ],
        roles: [
          {required: true, validator: validateRoles, trigger: 'change' }
        ],
        username: [
          { required: true,validator: validateUsername, trigger: 'blur' }
        ],
        teacherSchools: [
          { required: true, message: '请选择老师关联学校', trigger: 'change' }
        ],
        adminSchools: [
          { required: true, message: '请选择管理员关联学校', trigger: 'change' }
        ],
        studentSchool: [
          { required: true, message: '请选择学生关联学校', trigger: 'change' }
        ]
      },
      gradeList: USER_GRADE_MAP
    }
  },
  watch: {
    value(val) {
      this.visible = val;
      if (val) {
        if (this.isEdit && this.editData) {
          this.populateEditData();
        } else {
          this.resetForm();
        }
      }
    },
    visible(val) {
      this.$emit('input', val);
    },
    editData: {
      handler(newVal) {
        if (newVal && this.isEdit && this.visible) {
          this.populateEditData();
        }
      },
      deep: true
    }
  },
  created() {
    this.getRoleUserSchools();
  },
  methods: {
    // 重置表单
    resetForm() {
      this.formData = {
        level: 'MATHS_TALENTS_1',
        mobile: '',
        roles: [],
        username: '',
        adminSchools: [],
        teacherSchools: [],
        studentSchool: '',
        grade: ''
      };
      this.$nextTick(() => {
        if (this.$refs.createForm) {
          this.$refs.createForm.clearValidate();
        }
      });
    },
    // 查询所有学校数据
    getRoleUserSchools() {
      getUserSchools().then(res => {
        if(res.code === 200 && res.body?.schools){
          this.schoolList = res.body?.schools;
        }
      })
    },
    // 填充编辑数据
    populateEditData() {
      if (!this.editData) return;

      // 基础信息
      this.formData.level = this.editData.level || 'MATHS_TALENTS_1';
      this.formData.mobile = this.editData.mobile || '';
      this.formData.username = this.editData.username || '';
      this.formData.roles = this.editData.roles || [];

      // 学校信息回显
      this.formData.adminSchools = [];
      this.formData.teacherSchools = [];
      this.formData.studentSchool = '';
      this.formData.grade = '';

      if (this.editData.schoolRelations && this.editData.schoolRelations.length > 0) {
        // 按角色分组处理学校关联数据
        const adminSchools = [];
        const teacherSchools = [];
        let studentSchool = '';

        this.editData.schoolRelations.forEach(school => {
          if (school.role === 'ADMIN') {
            if (school.schoolId === 0) {
              // 如果schoolId为0，表示选择了"全部"
              adminSchools.push(0);
            } else if (school.schoolId) {
              adminSchools.push(school.schoolId);
            }
          } else if (school.role === 'TEACHER') {
            if (school.schoolId === 0) {
              // 如果schoolId为0，表示选择了"全部"
              teacherSchools.push(0);
            } else if (school.schoolId) {
              teacherSchools.push(school.schoolId);
            }
          } else if (school.role === 'STUDENT') {
            // 学生只能关联一个学校，取第一个
            if (!studentSchool) {
              studentSchool = school.schoolId || '';
            }
          }
        });

        // 设置到表单数据中
        this.formData.adminSchools = adminSchools;
        this.formData.teacherSchools = teacherSchools;
        this.formData.studentSchool = studentSchool;
      }

      // 学生年级
      if (this.editData.grade) {
        this.formData.grade = this.editData.grade;
      }

      this.$nextTick(() => {
        if (this.$refs.createForm) {
          this.$refs.createForm.clearValidate();
        }
      });
    },

    // 统一关闭弹窗
    handleModalClose() {
      if (this.successVisible) {
        this.handleSuccessClose();
      } else {
        this.handleClose();
      }
    },

    // 关闭弹窗
    handleClose() {
      this.visible = false;
      this.resetForm();
    },

    // 取消
    handleCancel() {
      this.handleClose();
    },

    // 提交
    handleSubmit() {
      // 动态设置验证规则
      this.setDynamicValidationRules();

      this.$refs.createForm.validate((valid) => {
        if (valid) {
          this.submitting = true;
          // 构建提交数据
          const submitData = this.buildSubmitData();
          console.log('提交数据:', submitData);
          createUser(submitData).then(res => {
            if (res.code === 200 && res?.body?.user) {
              this.successData = {
                ...res.body.user,
                adminSchools: this.getSchoolNames(this.formData.adminSchools),
                teacherSchools: this.getSchoolNames(this.formData.teacherSchools),
                studentSchool: this.getSchoolName(this.formData.studentSchool),
              }
              this.successVisible = true;
              this.submitting = false;
              this.visible = false;
              // 通知父组件刷新列表
              this.$emit('success');
            }else{
              this.$message.error(res?.message || '创建失败');
            }
          }).catch(err => {
            this.$message.error(err?.message || '创建失败');
          }).finally(() => {
            this.submitting = false;
          })
        }
      });
    },

    // 构建提交数据
    buildSubmitData() {
      const schools = [];

      // 处理管理员学校
      if (this.formData.roles.includes('ADMIN') && this.formData.adminSchools.length > 0) {
        let adminSchoolIds = this.formData.adminSchools;
        schools.push({
          role: 'ADMIN',
          schoolIds: adminSchoolIds
        });
      }

      // 处理老师学校
      if (this.formData.roles.includes('TEACHER') && this.formData.teacherSchools.length > 0) {
        let teacherSchoolIds = this.formData.teacherSchools;
        schools.push({
          role: 'TEACHER',
          schoolIds: teacherSchoolIds
        });
      }

      // 处理学生学校
      if (this.formData.roles.includes('STUDENT') && this.formData.studentSchool) {
        let studentSchoolIds = [this.formData.studentSchool];
        schools.push({
          role: 'STUDENT',
          schoolIds: studentSchoolIds
        });
      }

      return {
        identityId:this.editData? this.editData?.identityId : null,
        level: this.formData.level,
        username: this.formData.username ? this.formData.username.trim() : '', // 过滤空格
        mobile: this.formData.mobile,
        schools: schools,
        roles: this.formData.roles,
        grade: this.formData.grade || '' // 只有学生角色才有年级
      };
    },

    // 获取学校名称（多选）
    getSchoolNames(schoolIds) {
      if (!schoolIds || schoolIds.length === 0) return '';
      if (schoolIds.includes(0)) return '全部';

      const names = schoolIds.map(id => {
        const school = this.schoolList.find(s => s.id === id);
        return school ? school.schoolName : '';
      }).filter(name => name);

      return names.join(' | ');
    },

    // 获取学校名称（单选）
    getSchoolName(schoolId) {
      if (!schoolId) return '';
      if (schoolId === 0) return '全部';

      const school = this.schoolList.find(s => s.id === schoolId);
      return school ? school.schoolName : '';
    },
    // 复制到剪贴板
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('复制成功');
        }).catch(() => {
          this.fallbackCopyTextToClipboard(text);
        });
      } else {
        this.fallbackCopyTextToClipboard(text);
      }
    },

    // 备用复制方法
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
        this.$message.success('复制成功');
      } catch (err) {
        this.$message.error('复制失败');
      }

      document.body.removeChild(textArea);
    },

    // 成功弹窗关闭
    handleSuccessClose() {
      this.successVisible = false;
      this.resetForm();
    },

    // 角色变化处理
    handleRoleChange(selectedRoles) {
      // 更新表单数据
      this.formData.roles = selectedRoles;

      // 清空相关的学校选择
      if (!selectedRoles.includes('ADMIN')) {
        this.formData.adminSchools = [];
      }
      if (!selectedRoles.includes('TEACHER')) {
        this.formData.teacherSchools = [];
      }
      if (!selectedRoles.includes('STUDENT')) {
        this.formData.studentSchool = '';
        this.formData.grade = '';
      }
    },

    // 管理员学校选择变化处理
    handleAdminSchoolChange(selectedSchools) {
      // 如果选择了"全部"，清空其他选项
      if (selectedSchools.includes(0)) {
        this.formData.adminSchools = [0];
      }
    },

    // 老师学校选择变化处理
    handleTeacherSchoolChange(selectedSchools) {
      // 如果选择了"全部"，清空其他选项
      if (selectedSchools.includes(0)) {
        this.formData.teacherSchools = [0];
      }
    },

    // 动态设置验证规则
    setDynamicValidationRules() {
      const rules = { ...this.rules };

      // 根据选择的角色动态设置验证规则
      if (this.formData.roles.includes('ADMIN')) {
        rules.adminSchools = [
          { validator: this.validateAdminSchools, trigger: 'change' }
        ];
      } else {
        delete rules.adminSchools;
      }

      if (this.formData.roles.includes('TEACHER')) {
        rules.teacherSchools = [
          { validator: this.validateTeacherSchools, trigger: 'change' }
        ];
      } else {
        delete rules.teacherSchools;
      }

      if (this.formData.roles.includes('STUDENT')) {
        rules.studentSchool = [
          { validator: this.validateStudentSchool, trigger: 'change' }
        ];
        // rules.grade = [
        //   { validator: this.validateStudentGrade, trigger: 'change' }
        // ];
      } else {
        delete rules.studentSchool;
        delete rules.grade;
      }

      // 更新表单验证规则
      this.$refs.createForm.rules = rules;
    },

    // 验证方法
    validateAdminSchools(rule, value, callback) {
      if (!value || value.length === 0) {
        callback(new Error('请选择管理员关联学校'));
      } else {
        callback();
      }
    },

    validateTeacherSchools(rule, value, callback) {
      if (!value || value.length === 0) {
        callback(new Error('请选择老师关联学校'));
      } else {
        callback();
      }
    },

    validateStudentSchool(rule, value, callback) {
      if (!value.toString()) {
        callback(new Error('请选择学生关联学校'));
      } else {
        callback();
      }
    },

    // validateStudentGrade(rule, value, callback) {
    //   if (!value) {
    //     callback(new Error('请选择学生年级'));
    //   } else {
    //     callback();
    //   }
    // }
  }
}
</script>

<style scoped lang="less">
.create-user-modal /deep/ .base-modal_title {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: 600;
  color: #000000E5;
  margin-bottom: 24px;
  width: 100%;
  .title_ic {
    width: 24px;
    height: 24px;
    background: url('../images/user.png') center / contain no-repeat;
    margin-right: 6px;
  }
}
.create-user-modal /deep/ .base-modal_cnt{
  padding: 40px 60px 48px;
}
.modal-content{
  width: 500px;
}
.create-form-content {
  min-width: 500px;
  max-width: 600px;
  .el-input,.el-select{
    width: 280px;
  }
  .form-footer {
   display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 24px;
    padding-top: 16px;
    .el-button {
      margin-left: 12px;
      height: 48px;
      width: 172px;
      line-height: 48px;
      text-align: center;
      border-radius: 90px;
      border: none;
      outline: none;
      font-size: 14px;
      font-weight: 500;
      padding: 0 24px;
      background: #E60012;
      color: #fff;
      &:first-child {
        margin-left: 0;
        background: #F2F3F5;
        color: #000000E5;
      }
    }
  }
}

.success-content {
  .info-item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    font-size: 16px;
    .role-tags{
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .label {
      font-weight: 500;
      color: #000000E5;
      margin-right: 24px;
      min-width: 100px;
      text-align: left;
      width: 96px;
    }
    .value {
      color: #1D2129;
      font-weight: 400;
      text-align: left;
    }

    .role-tags {
      .el-tag {
        margin-right: 8px;
      }
    }
  }

  .account-info {
    background: #F5F6F9;
    padding: 0 48px;
    box-sizing: border-box;
    border-radius: 12px;
    margin-top: 24px;
    height: 144px;
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    position: relative;
    .account-item {
      display: flex;
      align-items: center;
      color: #1D2129;
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 24px;
      &:last-child {
        margin-bottom: 0;
      }

      .label {
        font-weight: 500;
        color: #1D2129;
        margin-right: 8px;
        min-width: 60px;
      }

      .value {
        color: #1D2129;
        flex: 1;
        font-family: monospace;
        text-align: left;
        word-break: break-all;
      }

      .el-button {
        color: #3491FA;
        padding: 0;
        margin-left: 8px;
        position: absolute;
        right: 48px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }

  .success-footer {
    text-align: center;
    margin-top: 24px;
    padding-top: 16px;
    border-top: 1px solid #e4e7ed;
  }
}
@media screen and (max-height: 800px) {
  .create-user-modal{
    /deep/ .base-modal_cnt {
      min-height:180px;
      overflow: hidden;
      padding: 40px;
    }
    .el-form {
      max-height: 400px;
      overflow-y: scroll;
    }
  }
}
</style>

<style lang="less">
/* 全局样式覆盖 */
.create-form-content {
  .el-form-item__label {
    font-size: 14px;
    color: #1D2129;
    font-weight: 500;
    width: 140px !important;
  }
  .el-form-item__content{
    text-align: left;
  }
  .el-checkbox-group {
    .el-checkbox {
      margin-right: 20px;

      .el-checkbox__label {
        font-size: 14px;
        color: #1D2129;
      }

      &.is-disabled {
        .el-checkbox__label {
          color: #C0C4CC;
        }
      }
    }
  }

  .el-radio-group {
    .el-radio {
      margin-right: 20px;

      .el-radio__label {
        font-size: 14px;
        color: #1D2129;
      }
    }
  }
}
</style>
